'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function addStereoAudioSupport(mediaAudio) {
  var audioSupport = undefined;
  var stereoAudioSupport = {
    channelCount: 2,
    echoCancellation: false,
    autoGainControl: false,
    noiseSuppression: false
  };
  if (typeof mediaAudio === 'object') {
    audioSupport = Object.assign({}, mediaAudio, stereoAudioSupport);
  } else {
    audioSupport = stereoAudioSupport;
  }
  return audioSupport;
}
exports.addStereoAudioSupport = addStereoAudioSupport;